import { object, string } from 'yup';

import {
	EOranConfigurationDataFieldNames,
} from '@interfaces/cmModule/configurationData';

import { regExpSchemaNameImport } from '@constants/regExp';
import {
	getMaxLengthErrMsg,
	mandatoryErrMessage,
	validationErrMessages,
} from '@constants/validationConstants';
import { MAX_50_LENGTH } from '@constants/validationMessages';
import { configurationDataFormLabels } from '@components/routes/CmModule/ConfigurationDataModelManagement/constants';

const name = 'Yang model collection';

export const schema = object().shape({
	[EOranConfigurationDataFieldNames.NAME]: object({
		value: string()
			.trim()
			.nullable()
			.required(mandatoryErrMessage(name))
			.max(MAX_50_LENGTH,
				getMaxLengthErrMsg(configurationDataFormLabels[EOranConfigurationDataFieldNames.NAME], MAX_50_LENGTH),
			)
			.matches(
				regExpSchemaNameImport,
				validationErrMessages.nameOranSchema,
			),
	})
		.nullable()
		.required(mandatoryErrMessage(name)),
});
